<template>
  <div class="fileinput">
    <File v-for="(f, i) in files" :key="f.name + i" :name="f.name" :size="filesizes[i]" :ext="fileexts[i]" :wrongFileType="forbiddenFileExts.includes(fileexts[i])" @delete="removeFile(i)" @edit="editFile(i)" />
    <label class="fileinput__label" tabindex="0">
      <span class="fileinput__label-text">Загрузить {{ filenames.length ? ' ещё ' : '' }} файл</span>
      <input ref="input" type="file" @change="addFiles" :accept="allowedext.map(el => '.' + el).join(',')" tabindex="-1" :name="name" :multiple="multiple">
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import filesinfo from '../../mixins/filesinfo';
import File from '../File.vue'

export default {
  mixins: [filesinfo],
  data: () => ({
    filseSizeMbLimit: 10,
    files: [],
    dt: new DataTransfer()
  }),
  props: {
    modelValue: {},
    name: { type: String, required: true },
    multiple: { type: Boolean, default: true },
    forbiddenFileExts: { type: Array, default: () => [] }
  },
  mounted() {
    if (this.modelValue === undefined)
      this.$emit('modelValue', [])
  },
  methods: {
    addFiles(e) {
      e.preventDefault();
      let files = [...e.target.files];

      if (files && files.length) {
        files = files.filter(f => {
          let ext = f.name.split('.').pop().toLowerCase(), size = f.size;
          if (!this.allowedext.includes(ext))
            return alert('Неверное расширение файла: ' + ext);
          if (size > 1024 * 1024 * this.filseSizeMbLimit)
            return false;
          if (this.filenames.includes(f.name))
            return false;
          return true;
        });
        for (let f of files)
          this.dt.items.add(f);
        this.files = Array.from(this.dt.files);
        this.$refs.input.files = this.dt.files;
        this.$emit("update:modelValue", this.$refs.input.files);
      }
    },
    removeFile(index) {
      this.dt.items.remove(index);
      this.files = Array.from(this.dt.files);
      this.$refs.input.files = this.dt.files;
      this.$emit("update:modelValue", this.$refs.input.files);
    },
    editFile(index) {
      this.removeFile(index)
      this.$refs.input.click()
    }
  },
  computed: {
    ...mapState(['allowedext'])
  },
  components: { File }
}
</script>

<style lang="sass" scoped>
.fileinput
  margin-bottom: 40px
  @include for-mob
    margin-bottom: 24px
  &__label
    cursor: pointer
    position: relative
    &::after
      content: ''
      position: absolute
      top: -5px
      left: -5px
      right: -5px
      bottom: -5px
    input
      position: absolute
      opacity: 0
      pointer-events: none
      width: 0
      height: 0
  &__label-text
    color: colors.$newred
    font-size: 16px
    line-height: 1.28
</style>